<template>
  <div class="p-6">
    <!-- Language Switcher -->
    <div class="max-w-5xl mx-auto mb-4 flex justify-end">
      <div class="relative">
        <div
          class="relative inline-flex items-center gap-1 rounded-lg border border-white/30 bg-gray-100/80 backdrop-blur-sm shadow-sm hover:shadow-md transition-all duration-300 px-1 py-1 overflow-hidden"
        >
          <div
            v-for="l in locales"
            :key="l.code"
            @click="setLanguage(l.code)"
            :class="[
              'flex items-center px-4 py-1.5 rounded-md text-sm font-medium transition-all duration-300 relative cursor-pointer select-none',
              isActive(l.code)
                ? 'text-gray-900 shadow-sm'
                : 'text-gray-700 hover:text-gray-900',
            ]"
          >
            <span class="mr-2">{{ l.flag }}</span>
            {{ l.label }}
            <span
              v-if="isActive(l.code)"
              class="pointer-events-none absolute inset-0 rounded-md"
              style="
                background: linear-gradient(
                  120deg,
                  rgba(255, 255, 255, 0.25) 0%,
                  rgba(255, 255, 255, 1) 100%
                );
                opacity: 1;
                z-index: -1;
              "
            ></span>
          </div>
        </div>

        <!-- Subtle glossy rim like other cards/tags -->
        <div
          class="absolute inset-0 rounded-lg bg-gradient-to-br from-white/15 to-transparent pointer-events-none"
        ></div>
      </div>
    </div>

    <div
      class="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-8 grid grid-cols-1 md:grid-cols-3 gap-6"
    >
      <!-- Left Panel -->
      <div class="md:col-span-1 border-r pr-6">
        <ProfileHeader />
        <SkillsList :highlightedSkillIds="highlightedSkillIds" />
        <Languages />
      </div>

      <!-- Right Panel -->
      <div class="md:col-span-2">
        <WorkExperience @active-skill-ids="highlightedSkillIds = $event" />
        <Education />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import ProfileHeader from "./components/ProfileHeader.vue";
import SkillsList from "./components/SkillsList.vue";
import Languages from "./components/Languages.vue";
import WorkExperience from "./components/WorkExperience.vue";
import Education from "./components/Education.vue";

@Options({
  components: {
    ProfileHeader,
    SkillsList,
    Languages,
    WorkExperience,
    Education,
  },
})
export default class App extends Vue {
  highlightedSkillIds: string[] = [];
  locales = [
    { code: "sk", flag: "🇸🇰", label: "SK" },
    { code: "en", flag: "🇬🇧", label: "EN" },
  ];

  isActive(code: string) {
    return this.$i18n.locale === code;
  }

  setLanguage(code: string) {
    this.$i18n.locale = code;
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
